import { APIService } from '@/services/api';
import { APIRoutes } from '@/services/api.routes';
import { isImpersonating } from '@/services/impersonation';

const REFRESH_THRESHOLD_S = 7 * 24 * 60 * 60;

let inflight: Promise<void> | null = null;

export async function refreshTokenIfNeeded(): Promise<void> {
  if (isImpersonating()) return;

  const remaining = APIService.inst.getTokenExpirySeconds();
  if (remaining === null) return;
  if (remaining <= 0) return;
  if (remaining > REFRESH_THRESHOLD_S) return;

  if (inflight !== null) return inflight;

  inflight = (async () => {
    try {
      const { token } = await APIRoutes.refreshToken();
      APIService.inst.setToken(token);
    } catch {
      // Swallow errors: a true 401 already triggers onUnauthorizedCallback in
      // executeRequest. Transient network errors should be retried on the next
      // refresh trigger.
    } finally {
      inflight = null;
    }
  })();

  return inflight;
}
